import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-ltms-error',
    templateUrl: './ltms-error.component.html',
    styleUrls: ['./ltms-error.component.scss'],
    imports: [NgIf]
})
export class LtmsErrorComponent implements OnInit {
  @Input() code:string="404"
  errorsDetail:any={
    "404":{
      "icon":"",
      "description":"No data available for selected filters."
    },
    "500":{
      "icon":"assets/images/exceded-loading.svg",
      "description":"We encountered a problem retrieving the data. Please try again or refresh the page"
    },
    "408":{
      "icon":"assets/images/server-error.svg",
      "description":"The request is taking longer than expected. Please wait a moment and try again."
    }
  }
  error:any={}
  ngOnInit() {
    // this.showError();
  }
  ngOnChanges(){
    this.showError();
  }

  showError(){
    if(this.errorsDetail[this.code]){
      this.error = this.errorsDetail[this.code]
    }else{
      this.error = this.errorsDetail["no_result_found"]
    }
  }
}
